import OrderPing from "../Assets/order.mp3";
import { Context, createContext, useState, useContext } from "react";

export interface IRootContext {
    audio: HTMLAudioElement;
}

/**
 * ## RootContext
 */
const RootContext: Context<IRootContext> = createContext<IRootContext>(null as any);

RootContext.displayName = "RootContext";

interface IRootContextProviderProps {}

/**
 * ## Root context provider component
 *
 */
export const RootContextProvider: React.FC<IRootContextProviderProps> = (props) => {
    const [audio] = useState<HTMLAudioElement>(
        (() => {
            const sound = document.createElement("audio");
            sound.id = "ping";
            sound.src = OrderPing;
            sound.volume = 1;
            sound.style.width = "0px";
            sound.style.height = "0px";
            sound.style.position = "absolute";
            sound.style.opacity = "0";
            document.body.appendChild(sound);
            return sound;
        })()
    );

    return (
        <RootContext.Provider
            value={{
                audio
            }}
        >
            {props.children}
        </RootContext.Provider>
    );
};

export const useRoot = (): IRootContext => useContext(RootContext);
